import React from 'react';

export const parseMarkdownText = (text: string): React.ReactNode => {
  if (!text) return null;

  // Split by line breaks first
  const lines = text.split('\n');
  
  return lines.map((line, lineIndex) => {
    if (!line.trim()) {
      return <br key={lineIndex} />;
    }

    // Parse bold text within each line
    const parts = line.split(/(\*\*[^*]+\*\*)/g);
    
    const parsedLine = parts.map((part, partIndex) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        const boldText = part.slice(2, -2);
        return (
          <strong key={`${lineIndex}-${partIndex}`} className="font-bold text-white">
            {boldText}
          </strong>
        );
      }
      return part;
    });

    return (
      <React.Fragment key={lineIndex}>
        {parsedLine}
        {lineIndex < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
};